import axios from "@/app/Axios";
import routerProtected from "@/app/routerProtected";

class ArmasService {
  /* armas = {
    id: 0,
    id_policia: 0,
    gestion_dotacion: 0,
    serie_arma: "",
    calibre: "",
    marca: "",
    modelo: "",
    id_procedencia: 0,
    cargadores: 0,
    observaciones: "",
  };

  constructor(armas) {
    this.armas = armas || { ...this.armas };
    routerProtected();
  }

  setFill(armas) {
    if (typeof this.armas !== 'object') {
      this.armas = {};
    }

    this.armas.id = armas.id || 0;
    this.armas.id_policia = armas.id_policia || 0;
    this.armas.gestion_dotacion = armas.gestion_dotacion || 0;
    this.armas.serie_arma = armas.serie_arma || "";
    this.armas.calibre = armas.calibre || "";
    this.armas.marca = armas.marca || "";
    this.armas.modelo = armas.modelo || "";
    this.armas.id_procedencia = armas.id_procedencia || 0;
    this.armas.cargadores = armas.cargadores || 0;
    this.armas.observaciones = armas.observaciones || "";
  }

  getFill() {
    return this.armas;
  } */

  async index() {
    try {
      const response = await axios.get("/getarmas");
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }

  async store(armas) {
    try {
      const response = await axios.post("/postarmas", armas);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }

  async destroy() {
    const id_registro = this.getFill().id;

    try {
      const response = await axios.delete(`/deletearmas/${id_registro}`);
      return response.data;
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
      return error.response.data;
    }
  }

  async update() {
    const id_registro = this.getFill().id;

    try {
      const response = await axios.put(`/putarmas/${id_registro}`, this.getFill());
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el registro:", error);
      return error.response.data;
    }
  }
}

export default ArmasService;
